import { Component } from '@angular/core';

@Component({
	selector: 'app-single-page',
	templateUrl: './single-page.component.html',
	styleUrls: ['./single-page.component.scss']
})
export class SinglePageComponent {}
